import React, { useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Search } from '@mui/icons-material';
import _debounce from 'lodash.debounce';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';





import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';

import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import VisibilityIcon from '@mui/icons-material/Visibility';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Badge from '@mui/material/Badge';
import axios from "axios";
import swal from "sweetalert";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


import { useHistory } from "react-router-dom";
import Input from '@mui/material/Input';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Stack from '@mui/material/Stack';
import AttachmentIcon from '@mui/icons-material/Attachment';
import Grid from '@mui/material/Grid';

function createData(
    id,
    title,
    code, type, dimensions, price, exhibitor, status,


) {
    return { id, title, code, type, dimensions, price, exhibitor, status };
}



const rows = [
    createData(1, "ssss ipsum dolor sit amet, ", '01', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(2, "ssss ipsum dolor sit amet, ", '09', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(3, "ssss ipsum dolor sit amet, ", '07', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(4, "ssss ipsum dolor sit amet, ", '08', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(5, "ssss ipsum dolor sit amet, ", '05', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(6, "ssss ipsum dolor sit amet, ", '09', 'squir', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(7, "ssss ipsum dolor sit amet, ", '07', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(8, "ssss ipsum dolor sit amet, ", '11', 'circle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(9, "ssss ipsum dolor sit amet, ", '41', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(10, "ssss ipsum dolor sit amet, ", '51', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(11, "ssss ipsum dolor sit amet, ", '21', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(12, "ssss ipsum dolor sit amet, ", '31', 'Round', '5m', '500/-SR', 'Meshall', 'Booked'),
    createData(13, "ssss ipsum dolor sit amet, ", '41', 'Tringle', '5m', '500/-SR', 'Meshall', 'Booked'),


].sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const ManageWorkShopParticpant = () => {
    const history = useHistory();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchText, setSearchText] = useState('');

    const [permissions, setrPermissions] = useState([]);
    const [allData, setAllData] = useState([]);
    const [participantIndex, setParticipantIndex] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
    React.useEffect(() => {
        return () => {
            setAllData(rows)
        };
    }, []);
    const eventid = localStorage.getItem('eventid')
    React.useEffect(() => {
        axios.get(`api/getpermissionByRole`).then(res => {

            if (res.status === 200) {
                const datad = res.data.data.permissions;
                setrPermissions(datad)
            } else {

            }
        })

    }, []);



    React.useEffect(() => {
        axios.get(`api/workshop-category-front-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wcategoryData = res.data.workshopCategories;
                setWorkShopCategoryData(wcategoryData);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);



    React.useEffect(() => {
        axios.get(`api/workshop-particpant-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wpartiticpantData = res.data.wpindex;
                setParticipantIndex(wpartiticpantData);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, [selectedFile]);





    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleFileUpload = () => {

        axios.get('/sanctum/csrf-cookie')
            .then(() => {
                // Once CSRF token is obtained, create FormData and append the file
                const formData = new FormData();
                formData.append('file', selectedFile);

                // Send the FormData to the server
                axios.post(`/api/workshop-particpant-csv-upload/${eventid}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data' // Set appropriate content type
                    }
                })
                    .then(res => {
                        if (res.data.status === 200) {

                            const messageWithCount = `${res.data.message} ${res.data.record_count} records imported.`;
                            swal('Success', messageWithCount, 'success');
                            setSelectedFile(null);
                            document.getElementById('contained-button-file').value = '';
                            history.push('/admin/workshop/manage-particpant');

                        } else {
                            swal('Error', 'File not uploaded1', 'error');

                        }
                    })
                    .catch(error => {
                        console.error('Error uploading file:', error);
                        swal('Error', 'File not uploaded2', 'error');
                    })
            })
            .catch(error => {
                console.error('Error fetching CSRF token:', error);
                
            });
    };

    //console.log(workshopCategoryData);
    const workhopCategFilterData = workshopCategoryData.map(item => ({
        ID: item.id,
        category_name: item.workshop_category_title

    }));

    // const downloadCsvSample = () => {
    //     const data = [

    //         ["participant_workshop_categoy_id", "name_title", "participant_name", "participant_saudi_council_no", "participant_email", "participant_gender", "participant_profession", "participant_phone_number", "participant_country", "participant_city", "participant_address", "participant_company"],
    //         [1, "Mr", "Jhon", "0000", "jhon@test.com", '"0 "', "doctor", "05123456", "Saudi Arbia", "Al Riyadh", "Al riyadh ", "companyName"],
    //         [1, "Ms", "Lily", "0000", "lily@test.com", '1', "doctor", "05123456", "Saudi Arbia", "Al Riyadh", "Al riyadh ", "companyName"],
    //         ["", "", "", "", "", "", "", "", "", "", "", "", ""],
    //         ["", "", "", "", "", "", "", "", "", "", "", "", ""],
    //         ["note These are the id of each category but before uploading remove the section"],
    //         ["ID", "category_name"],
    //         ...workhopCategFilterData.map(row => [row.ID, row.category_name]),
    //         [, "", "", "", "", '"0 for male , 1 for female"', "", "", " ", " ", "  ", ""],
    //     ];
    //     const csvContent = data.map(row => row.join(',')).join('\n');
    //     const blob = new Blob([csvContent], { type: 'text/csv' });
    //     const link = document.createElement('a');
    //     link.href = window.URL.createObjectURL(blob);
    //     link.download = 'sample.csv';
    //     link.click();
    // };
    const downloadCsvSample = () => {
        const data = [
            // CSV headers
            ["participant_workshop_category_id", "name_title", "participant_name", "participant_saudi_council_no", "participant_email", "participant_gender", "participant_profession", "participant_phone_number", "participant_country", "participant_city", "participant_address", "participant_company"],
            
            // Sample participant rows
            [1, "Mr", "John", "0000", "john@test.com", "0", "doctor", "05123456", "Saudi Arabia", "Al Riyadh", "Al Riyadh", "companyName"],
            [1, "Ms", "Lily", "0000", "lily@test.com", "1", "doctor", "05123456", "Saudi Arabia", "Al Riyadh", "Al Riyadh", "companyName"],
            
            // Empty rows for further inputs
            ["", "", "", "", "", "", "", "", "", "", "", ""],
            ["", "", "", "", "", "", "", "", "", "", "", ""],
            
            // Note or instructions section
            ["Note: These are the IDs of each category. Before uploading, remove this section."],
            
            // Workshop category headers
            ["ID", "category_name"],
            
            // Workshop category data
            ...workhopCategFilterData.map(row => [row.ID, row.category_name]),
            
            // Additional instructions for gender values
            ["", "", "", "", "", "0 for male, 1 for female", "", "", "", "", "", ""]
        ];
    
        // Convert data to CSV format
        const csvContent = data.map(row => row.join(',')).join('\n');
        
        // Create and trigger file download
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'sample.csv';
        link.click();
    };
    


    const CustomFieldDelete = (e, id) => {
        e.preventDefault();
        const thisClicked = e.currentTarget;
        thisClicked.innerText = " Deleting..."
        axios.get(`api/status-list-customfield/${id}`).then(res => {
            if (res.data.status === 200) {
                //swal("Success", res.data.message, "success");
                thisClicked.closest("tr").remove();
            }
            else if (res.data.status === 404) {
                this.innText = "delete";
            }
        });
    }


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const filteredRows = rows.filter((row) =>
        Object.values(row).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
        )

    );
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    const [searchTerm, setSearchTerm] = useState('');
    const filteredPosts = participantIndex.filter((row) =>
        //(row.phone && row.phone.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.particent_name && row.particent_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.particent_email && row.particent_email.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.particent_saudi_council_no && row.particent_saudi_council_no.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.particent_phone_number && row.particent_phone_number.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (row.wpjoin_as && row.wpjoin_as.join_as && row.wpjoin_as.join_as.toLowerCase().includes(searchTerm.toLowerCase()))
        //(row.role && row.role.toLowerCase().includes(searchTerm.toLowerCase()))
        // Add more fields with null checks as needed
    );
    const totalRecords = participantIndex.length;
    const filteredRecordsCount = filteredPosts.length;
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);



    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,


    return (
        <div style={{ margin: '1%', width: '100vw', marginLeft: '0%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    {
                        permissions['p_workshop-participant-add'] === true ?

                            <Button sx={{
                                float: 'right',
                                marginRight: '1%',
                                backgroundColor: backGroundButtonByEvent,
                                marginTop: '2%',
                                ":hover": {
                                    color: "white"
                                }
                            }}
                                color='success'
                                size='small'
                                variant='contained'
                                component={Link}
                                to="/admin/workshop/particpant">
                                Add New
                            </Button> : ""}
                </h4>

                <Card sx={{ width: '85vw', float: 'center' }} >
                    <CardContent >

                        <Box component="form" noValidate sx={{ mt: 3 }}>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Typography component="h1" variant="h5">
                                    Manage Workshop Participant
                                </Typography>
                                <Typography>
                                    Total Records: {totalRecords} | Filtered Records: {filteredRecordsCount}
                                </Typography>
                                <Grid container spacing={2} alignItems="center" justifyContent="flex-end">

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            fullWidth
                                            label="Filter By: Name"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </Grid>
                                    {
                                        permissions['p_workshop-participant-import'] === true ?
                                            <Grid item xs={6} sm={3} md={3}>
                                                {/* <input type="file" onChange={handleFileChange} id="contained-button-file"  /> */}
                                                <TextField id="contained-button-file" multiple type="file" onChange={handleFileChange} />
                                            </Grid> : ""}
                                    {
                                        permissions['p_workshop-participant-import'] === true ?
                                            <Grid item xs={6} sm={3} md={2}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleFileUpload}
                                                    disabled={!selectedFile} // Disable button if no file selected
                                                sx={{backgroundColor: backGroundButtonByEvent,}}>
                                                    Import File
                                                </Button>
                                            </Grid> : ""}
                                    {
                                        permissions['p_workshop-participant-import'] === true ?
                                            <Grid item xs={6} sm={3} md={2}>
                                                <Button variant="contained"  onClick={downloadCsvSample} sx={{backgroundColor: backGroundButtonByEvent,}}>
                                                    Export Sample
                                                </Button>
                                            </Grid> : ""}
                                </Grid>
                            </div>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell > #</TableCell>
                                            <TableCell align="left">Name</TableCell>
                                            <TableCell align="left">Email</TableCell>
                                            <TableCell align="left">Mobile No</TableCell>
                                            <TableCell align="left">Saudi council no</TableCell>
                                            <TableCell align="left">Coupon code</TableCell>
                                            <TableCell align="left">workshops</TableCell>
                                            <TableCell align="left">Join As</TableCell>
                                            <TableCell align="left">Action</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {filteredPosts && filteredPosts.slice(startIndex, endIndex).map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.id}</TableCell>
                                                <TableCell>{row.name_title}: {row.particent_name}</TableCell>
                                                <TableCell>{row.particent_email}</TableCell>
                                                <TableCell>{row.particent_phone_number}</TableCell>
                                                <TableCell>{row.particent_saudi_council_no}</TableCell>
                                                <TableCell>
                                                    {row.wpcoupon.map((rowCoupon, couponIndex) => (
                                                        <React.Fragment key={couponIndex}>
                                                            <div key={couponIndex}>{rowCoupon.coupon_code}</div><br></br>
                                                        </React.Fragment>
                                                    ))}
                                                </TableCell>

                                                <TableCell style={{ width: '20%' }}>
                                                    {row.wpworkshop.map((rowWorkshop, index) => (
                                                        <React.Fragment key={index}>
                                                            <div>{rowWorkshop.workshop_name}</div><br></br>
                                                        </React.Fragment>
                                                    ))}
                                                </TableCell>

                                                <TableCell>{row.wpjoin_as && row.wpjoin_as.join_as ? row.wpjoin_as.join_as : "Participant"}</TableCell>



                                                <TableCell>
                                                    {
                                                        permissions['p_workshop-participant-edit'] === true ?

                                                            <Button
                                                                sx={{
                                                                    margin: 1,
                                                                    ":hover": {
                                                                        color: "white"
                                                                    },
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                }}
                                                                color='primary'
                                                                size='small'
                                                                variant='contained'
                                                                component={Link}
                                                                to={`/admin/workshop/eidt-particpant/${row.id}`} >
                                                                {/* <EditNoteIcon /> */}
                                                                Edit WorkShop
                                                            </Button> : ""}
                                                    {
                                                        permissions['p_workshop-participant-delete'] === true ? 
                                                    <Button
                                                        sx={{
                                                            ":hover": {
                                                                color: "white"
                                                            },
                                                            backgroundColor: backGroundButtonByEvent,
                                                        }}
                                                        color='primary'
                                                        size='small'
                                                        variant='contained'
                                                        onClick={(e) => CustomFieldDelete(e, row.id)}
                                                    >
                                                        <DeleteIcon />
                                                    </Button> :""
                                                    }
                                                     {
                                                        permissions['p_workshop-participant-edit-information'] === true ? 
                                                    <Button
                                                        sx={{
                                                            margin: 1,
                                                            ":hover": {
                                                                color: "white"
                                                            },
                                                            backgroundColor: backGroundButtonByEvent,
                                                        }}
                                                        color='primary'
                                                        size='small'
                                                        variant='contained'
                                                        component={Link}
                                                        to={`/admin/workshop/basic-particpant/${row.id}`}
                                                    >
                                                        Edit Participant
                                                    </Button> :""}
                                                </TableCell>
                                            </TableRow>
                                        ))}

                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50, 100, 500, 1000, 10000, 100000,]}
                                    component="div"
                                    count={filteredRows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>

                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}

export default ManageWorkShopParticpant;
